<template>
  <div class="home">
    <Banner />
    <RecoList />
    <PopularList />
  </div>
</template>

<script>
import Banner from '@/components/layouts/Banner'
import RecoList from '@/components/recommendations/RecoList'
import PopularList from '@/components/recommendations/PopularList'

export default {
  name: 'home',
  components: { Banner, RecoList, PopularList },
}
</script>

<style>
</style>